export default {
    schema: 6,
    pageIndex: 'home',
    back: [],
    interruptions: [],
    character: null,
    health: null,
    impact: null,
    dieState: 'hidden', // hidden, pre, rolling, post
    dieValue: 3,
    impactWentUp: false,
    impactExplained: false,
    healthExplained: false,
    soundEnabled: true, // persists when starting over
};